import React, { useEffect, useState } from "react";
import "./UserProfilePage.css";
import api from "../../services/baseUrl";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function UserProfilePage({ username, userProfile }) {
  const [profile, setProfile] = useState(userProfile);
  const [initialProfile, setInitialProfile] = useState(userProfile);
  const [states, setStates] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setProfile(userProfile);
    setInitialProfile(userProfile);

    const fetchState = async () => {
      try {
        const response = await api.get(
          "/api/egazette-documents/libraries/all",
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const filteredResponse = response.data.sort((a, b) => {
          if (a.orderId === null) return -1; // Ensure null is always first
          if (b.orderId === null) return 1;
          return a.orderId - b.orderId; // Sort by orderId in ascending order
        });

        setStates(filteredResponse);
      } catch (error) {}
    };
    fetchState();
  }, [userProfile]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfile((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return; // prevent multiple submissions

    setIsSubmitting(true);

    const changedFields = Object.keys(profile)
      .filter((key) => profile[key] !== initialProfile[key])
      .map((key) => ({
        key: key,
        value: profile[key],
      }));

    await updateProfile(changedFields);
    setIsSubmitting(false);
  };

  const updateProfile = async (changedFields) => {
    toast.success("Sending your request...");
    const response = await api.post("/user/updateprofile", {
      username: username,
      requestedChanges: changedFields,
    });

    if (response.status === 200) {
      toast.success(response.data.message);
    }
  };

  return (
    <div className="user-profile-container">
      <form className="profile-form" onSubmit={handleSubmit}>
        <div className="form-grid">
          <label>
            Name:
            <input
              type="text"
              name="name"
              value={profile.name}
              onChange={handleChange}
            />
          </label>
          <label>
            Email:
            <input
              type="email"
              name="email"
              value={profile.email}
              onChange={handleChange}
            />
          </label>
          <label>
            Designation:
            <input
              type="text"
              name="designation"
              value={profile.designation}
              onChange={handleChange}
            />
          </label>
          <br />
          <label>
            Address Line 1:
            <input
              type="text"
              name="address1"
              value={profile.address1}
              onChange={handleChange}
            />
          </label>
          <label>
            Address Line 2:
            <input
              type="text"
              name="address2"
              value={profile.address2}
              onChange={handleChange}
            />
          </label>
          <label>
            City:
            <input
              type="text"
              name="city"
              value={profile.city}
              onChange={handleChange}
            />
          </label>
          <label>
            Postal Code:
            <input
              type="text"
              name="postalCode"
              value={profile.postalCode}
              onChange={handleChange}
            />
          </label>
          <label>
            State:
            <select name="state" value={profile.state} onChange={handleChange}>
              {states.map((state) => (
                <option key={state.id} value={state.id}>
                  {state.name}
                </option>
              ))}
            </select>
          </label>
          <label>
            Organization:
            <input
              type="text"
              name="organization"
              value={profile.organization}
              onChange={handleChange}
            />
          </label>
          <label>
            Contact No (Mobile):
            <input
              type="text"
              name="mobile"
              value={profile.mobile}
              onChange={handleChange}
            />
          </label>
          <label>
            Contact No (Office):
            <input
              type="text"
              name="office"
              value={profile.office}
              onChange={handleChange}
            />
          </label>
        </div>
        <button type="submit" disabled={isSubmitting}>
          {isSubmitting ? "Submitting..." : "Submit Profile Change Request"}
        </button>
      </form>
      <ToastContainer />
    </div>
  );
}
